$(function () {
     $('#learning-materials-slider').slick({
         infinite: false,
         slidesToShow: 1,
         slidesToScroll: 1,
         dots: true,
         arrows: false,
         autoplay: true
     });

     $("#learning-materials-slider .partners__image").on("click", function (e) {
         $(".learning-materials-gallery__img").first().click();
     });

     (function testimonialReveal() {
        var buttons = document.querySelectorAll('.testimonial__arrow-btn');

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                this.classList.toggle('active');
                var testimonial = button.closest('.testimonial');
                testimonial.classList.toggle('active');
            });
        });
    })();

    (function certDetailCardToggleItem() {
        var toggleTriggers = document.querySelectorAll('.cert-detail-card__item--toggle .cert-detail-card__item-title');

        toggleTriggers.forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                var toggleParent = this.closest('.cert-detail-card__item--toggle');
                toggleParent.classList.toggle('active');
            });
        });
    })();
});

window.addEventListener("scroll", () => {
    const chooseYourProgram = document.getElementById("chooseAProgram");
    const stickyNav = document.querySelector(".cert-detail-sticky-nav");

    if (!chooseYourProgram || !stickyNav) return;

    const chooseYourProgramBottom = chooseYourProgram.offsetTop + chooseYourProgram.offsetHeight;

    if (window.scrollY > chooseYourProgramBottom) {
        stickyNav.classList.add("active");
    } else {
        stickyNav.classList.remove("active");
    }
});
